<div class="team-wrap" *ngIf="list.length > 0">
  <h2 class="sec-title">{{ title }}</h2>
  <div class="row row-wrap">
    <div class="col-12 col-md-6" *ngFor="let item of list">
      <app-minimal-user-card [data]="item"></app-minimal-user-card>
    </div>
  </div>
</div>
